import { create } from 'zustand'

export const useTagStore = create((set) => ({
    tags: [],
    removeTag: (tag) => set((state) => ({ tags : state.tags.filter((t) => t !== tag) })),
    addTag: (newTag) => set((state) =>({ tags: [...state.tags, newTag] })),
    updateTags: (newTags) => set(() => ({ tags: newTags })),
    clearTags: () => set({ tags: [] }),
}))
